import * as types from "../actionTypes";

export function setAllTeams(payload) {
  return { type: types.SET_ALL_TEAMS, payload };
}

export function addTeamSuccess(payload) {
  return { type: types.ADD_TEAM_SUCCESS, payload };
}

export function addTestTeamDataSuccess(payload) {
  return { type: types.LOAD_TEST_TEAM_DATA_SUCCESS, payload };
}

export function removeTeamSuccess(payload) {
  return { type: types.REMOVE_TEAM_SUCCESS, payload };
}

export function updateTeamSuccess(payload) {
  return { type: types.UPDATE_TEAM_SUCCESS, payload };
}

export function clearTeamsSuccess() {
  return { type: types.CLEAR_TEAMS_SUCCESS };
}

export function registerTeamSuccess(payload) {
  return { type: types.REGISTER_TEAM_SUCCESS, payload };
}

export function setResults(payload) {
  return { type: types.SET_TEAM_RESULTS_SUCCESS, payload };
}

export function setCWResults(payload) {
  return { type: types.SET_TEAM_CW_RESULTS_SUCCESS, payload };
}

export function setBreakerAnswer(payload) {
  return { type: types.SET_TEAM_BREAKER_ANSWER_SUCCESS, payload };
}

export function setBreakerResultsSuccess(payload) {
  return { type: types.SET_BREAKER_RESULTS_SUCCESS, payload };
}

export function submitScoresSuccess(payload) {
  return { type: types.SUBMIT_SCORES_SUCCESS, payload };
}

export function teamScoresUpdated(payload) {
  return { type: types.TEAM_SCORES_UPDATED, payload };
}
